import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";

export abstract class DeckGroup {
    public cards: DeckCard[] = [];
    public count: number = 0;

    public constructor(public name: string, public iconSvg: string) {

    }

    public abstract isValid(deck: Deck, card: DeckCard): boolean;

    public addCard(card: DeckCard): void {
        this.cards.push(card);
        this.count += card.count + card.specialCount;
    }

    public removeCard(card: DeckCard): boolean {
        var removed: boolean = false;

        for (let i = 0; i < this.cards.length; ++ i) {
            if (this.cards[i].deckCardId === card.deckCardId) {
                this.cards.splice(i, 1);
                removed = true;
            }
        }

        if (removed) {
            // We can't just do "this.count -= card.count" in the loop earlier
            // because by the time the group is told of the card being removed, its count
            // has already been updated.
            this.recalculate();
        }

        return removed;
    }

    public recalculate(): void {
        this.count = 0;
        this.cards.forEach(c => {
            this.count += c.count + c.specialCount;
        });
    }
}